import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL, getMediaURL } from '../config';

const Footer = () => {
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [contactInfo, setContactInfo] = useState(null);
  const [socialMedia, setSocialMedia] = useState([]);
  const [siteInfo, setSiteInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Site bilgilerini ilk olarak alalım
        try {
          const siteInfoRes = await axios.get(`${API_URL}/api/site-infos?populate=*`);
          console.log('Full API Response:', JSON.stringify(siteInfoRes.data, null, 2));
          
          if (siteInfoRes.data.data && siteInfoRes.data.data.length > 0) {
            const siteData = siteInfoRes.data.data[0];
            console.log('Site Data (detailed):', JSON.stringify(siteData, null, 2));
            setSiteInfo(siteData);
          }
        } catch (error) {
          console.error('Site info fetch error:', error);
        }

        // Blog verileri
        try {
          const blogsRes = await axios.get(`${API_URL}/api/blogs?populate=*&sort[0]=publishedAt:desc&pagination[limit]=3`);
          console.log('Blogs API Response:', JSON.stringify(blogsRes.data, null, 2));
          if (blogsRes.data.data) {
            setRecentBlogs(blogsRes.data.data);
          }
        } catch (error) {
          console.error('Blogs fetch error:', error);
        }

        // İletişim bilgileri
        try {
          const contactRes = await axios.get(`${API_URL}/api/contact-infos?populate=*`);
          console.log('Contact Info API Response:', JSON.stringify(contactRes.data, null, 2));
          if (contactRes.data.data?.[0]) {
            setContactInfo(contactRes.data.data[0]);
          }
        } catch (error) {
          console.error('Contact info fetch error:', error);
        }

        // Sosyal medya
        try {
          const socialRes = await axios.get(`${API_URL}/api/social-medias?populate=*`);
          console.log('Social Media API Response:', JSON.stringify(socialRes.data, null, 2));
          if (socialRes.data.data) {
            setSocialMedia(socialRes.data.data);
          }
        } catch (error) {
          console.error('Social media fetch error:', error);
        }

        setLoading(false);
      } catch (error) {
        console.error('Footer veri yükleme hatası:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (siteInfo) {
      console.log('Final siteInfo state:', JSON.stringify(siteInfo, null, 2));
    }
  }, [siteInfo]);

  if (loading) return null;

  return (
    <footer className="bg-primary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo Sütunu */}
          <div className="flex items-start">
            <Link to="/" onClick={scrollToTop}>
              {siteInfo?.logo?.url && (
                <img 
                  src={getMediaURL(siteInfo.logo.url)}
                  alt={siteInfo.title || 'Site Logo'}
                  className="h-24 w-auto object-contain"
                />
              )}
            </Link>
          </div>

          {/* Boş Sütun */}
          <div></div>

          {/* Son Yazılar Sütunu */}
          <div>
            <h3 className="text-xl font-bold mb-4">Son Yazılar</h3>
            <ul className="space-y-3">
              {recentBlogs && recentBlogs.length > 0 && recentBlogs.map(blog => (
                <li key={blog.id}>
                  {blog?.title && (
                    <Link 
                      to={`/blog/${blog.id}`}
                      className="hover:text-gray-200 transition-colors line-clamp-1"
                    >
                      {blog.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim Sütunu */}
          <div>
            <h3 className="text-xl font-bold mb-4">İletişim</h3>
            {contactInfo && (
              <div className="space-y-3">
                {contactInfo.address && (
                  <p className="flex items-center text-sm">
                    <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {contactInfo.address}
                  </p>
                )}
                {contactInfo.phone && (
                  <p className="flex items-center text-sm">
                    <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    {contactInfo.phone}
                  </p>
                )}
                {contactInfo.email && (
                  <p className="flex items-center text-sm">
                    <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    {contactInfo.email}
                  </p>
                )}
              </div>
            )}
            {/* Sosyal Medya İkonları */}
            <div className="flex space-x-4 mt-6">
              {socialMedia && socialMedia.length > 0 && socialMedia.map(social => (
                <a
                  key={social.id}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-200 transition-colors"
                >
                  {social.icon ? (
                    <i className={social.icon} />
                  ) : (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Telif Hakkı Metni */}
        <div className="text-center text-sm mt-12 pt-8 border-t border-white/10">
          {siteInfo?.title} Hukuk Bürosu {new Date().getFullYear()}. Tüm hakları saklıdır.
        </div>
      </div>
    </footer>
  );
};

export default Footer;